export const ROLES = {
  ADMIN: "admin",
  AGENT: "user",
};

export const PERMISSIONS = {
  PROPERTY_VIEW: "property.view",
  PROPERTY_CREATE: "property.create",
  PROPERTY_EDIT: "property.edit",
  PROPERTY_IMPORT: "property.import",
  PROPERTY_DELETE: "property.delete",

  SEARCH_VIEW: "search.view",
  SEARCH_CREATE: "search.create",
  SEARCH_EDIT: "search.edit",
  SEARCH_DELETE: "search.delete",

  CLIENT_VIEW: "client.view",
  CLIENT_CREATE: "client.create",
  CLIENT_EDIT: "client.edit",

  SHARED_LINK_VIEW: "sharedLink.view",
  SHARED_LINK_CREATE: "sharedLink.create",
  SHARED_LINK_EDIT: "sharedLink.edit",
  SHARED_LINK_DELETE: "sharedLink.delete",

  SPECIAL_VIEW: "special.view",
  SPECIAL_CREATE: "special.create",
  SPECIAL_EDIT: "special.edit",
  SPECIAL_DELETE: "special.delete",

  COMMISSION_VIEW: "commission.view",
  COMMISSION_CREATE: "commission.create",
  COMMISSION_EDIT: "commission.edit",
  COMMISSION_DELETE: "commission.delete",

  DRIVE_VIEW: "drive.view",
  DRIVE_EDIT: "drive.edit",

  THREAD_VIEW: "thread.view",
  THREAD_EDIT: "thread.edit",

  MESSAGE_VIEW: "message.view",

  NOTIFICATION_VIEW: "notification.view",
  NOTIFICATION_EDIT: "notification.edit",

  CATEGORY_VIEW: "category.view",
  
  CLASSIFICATION_VIEW: "classification.view",
};